import {createAction} from "@reduxjs/toolkit";
import {ActivityPeriodSearchCriteria} from "@ots-frontend/ots-data";

export const setUIActivityPeriodSearchFilter = createAction<ActivityPeriodSearchCriteria>("ots-ui/activity-period/setSearchFilter");
